/**
 * The Senate action (rulebook p.7): advance one space on the senate track and
 * score that space's VP. Not available from the top space until the quarter
 * ends (the balance of power resets every disc to the start).
 */
import { addVp, afterAction, fail, playerOf, succeed, updatePlayer, } from '../internal.js';
import { MANIFESTS } from '../manifests.js';
export const SENATE_TOP = MANIFESTS.senateTrack.spaces.length - 1;
export function canAdvanceSenate(player) {
    return player.senate < SENATE_TOP;
}
/** Move a disc between senate stacks (top of the destination). */
export function moveSenateDisc(stacks, player, to) {
    return stacks.map((stack, i) => {
        const without = stack.filter((id) => id !== player);
        return i === to ? [...without, player] : without;
    });
}
export function senate(state, actor) {
    const player = playerOf(state, actor);
    if (!canAdvanceSenate(player))
        return fail('ILLEGAL', 'already on the top senate space this quarter');
    const to = player.senate + 1;
    const vp = MANIFESTS.senateTrack.spaces[to]?.vp ?? 0;
    let next = updatePlayer(state, actor, (pl) => ({ ...pl, senate: to }));
    next = {
        ...next,
        board: { ...next.board, senateStacks: moveSenateDisc(next.board.senateStacks, actor, to) },
    };
    next = addVp(next, actor, vp);
    return succeed(afterAction(next), [{ type: 'SenateAdvanced', player: actor, to, vp }]);
}
//# sourceMappingURL=senate.js.map